import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../styles/admin.css";

export default function Admin() {
    const [user, setUser] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();


    //KAPCSOLD VISSZA
    // useEffect(() => {
    //     // Lekérdezzük, hogy az admin be van-e jelentkezve
    //     fetch("https://focifanatik.hu/api/session_check.php", {
    //         credentials: "include"
    //     })
    //         .then((res) => res.json())
    //         .then((data) => {
    //             if (!data.loggedIn || data.is_admin !== 1) {
    //                 alert("Nincs jogosultságod az admin felülethez!");
    //                 navigate("/kezdolap");
    //             } else {
    //                 setUser(data);
    //             }
    //         })
    //         .catch((err) => console.error("Hiba a bejelentkezés ellenőrzésekor:", err));
    // }, [navigate]);

    return (
        <div className="admin-page">
            {/* Oldalsó menü */}
            <aside className={`admin-sidebar ${menuOpen ? "open" : ""}`}>
                <h4 className="admin-logo">⚙️ Admin</h4>
                <ul>
                    <li><Link className="nav-link" to={"/admin/kezdolap"}>Kezdőlap</Link></li>
                    <li><Link className="nav-link" to={"/admin/meccsek"}>Mérkőzések</Link></li>
                    <li><Link className="nav-link" to={"/admin/ligak"}>Ligák</Link></li>
                    <li><Link className="nav-link" to={"/admin/csapatok"}>Csapatok</Link></li>
                    <li><Link className="nav-link" to={"/admin/felhasznalok"}>Felhasználók</Link></li>
                    <li><Link className="nav-link" to={"/admin/statisztikak"}>Meccs Statisztikák</Link></li>
                    <li><Link className="nav-link" to={"/admin/statisztika-tipusok"}>Statisztika Tipusok</Link></li>
                    <li><Link className="nav-link" to={"/admin/emailek"}>Email Rendszer</Link></li>
                </ul>
            </aside>

            {/* Tartalomrész */}
            <main className="admin-content">
                <header className="admin-header">
                    <button
                        className="admin-menu-btn"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        ☰
                    </button>
                    <h3>Üdv, {user?.username || "Admin"}!</h3>
                </header>


            </main>
        </div>
    );
}



// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import "../../styles/admin.css";

// export default function Admin() {
//     const [user, setUser] = useState(null);
//     const [menuOpen, setMenuOpen] = useState(false);
//     const navigate = useNavigate();

//     useEffect(() => {
//         // Lekérdezzük, hogy az admin be van-e jelentkezve
//         fetch("https://focifanatik.hu/api/session_check.php", {
//             credentials: "include"
//         })
//             .then((res) => res.json())
//             .then((data) => {
//                 if (!data.loggedIn || data.is_admin !== 1) {
//                     alert("Nincs jogosultságod az admin felülethez!");
//                     navigate("/kezdolap");
//                 } else {
//                     setUser(data);
//                 }
//             })
//             .catch((err) => console.error("Hiba a bejelentkezés ellenőrzésekor:", err));
//     }, [navigate]);

//     return (
//         <div className="admin-page">
//             {/* Oldalsó menü */}
//             <aside className="admin-sidebar">
//                 <h4 className="admin-logo">⚙️ Admin</h4>
//                 <ul>
//                     <li><Link className="nav-link" to={"/admin/kezdolap"}>Kezdőlap</Link></li>
//                     <li><Link className="nav-link" to={"/admin/meccsek"}>Mérkőzések</Link></li>
//                     <li><Link className="nav-link" to={"/admin/ligak"}>Ligák</Link></li>
//                     <li><Link className="nav-link" to={"/admin/csapatok"}>Csapatok</Link></li>
//                     <li><Link className="nav-link" to={"/admin/felhasznalok"}>Felhasználók</Link></li>
//                     <li><Link className="nav-link" to={"/admin/statisztikak"}>Meccs Statisztikák</Link></li>
//                 </ul>
//             </aside>

//             {/* Tartalomrész */}
//             <main className="admin-content">
//                 <header className="admin-header">
//                     <h3>Üdv, {user?.username || "Admin"}!</h3>
//                 </header>

//             </main>
//         </div>
//     );
// }
